import ProcessAndPeople from "./ProcessAndPeople";

export { ProcessAndPeople };
export default ProcessAndPeople;
